<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { refreshMerchantBrand } from "@/utils/merchantBrand";

/**
 * Starter page component
 */
export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Starter page",
      items: [
        {
          text: "Utility",
          href: "/",
        },
        {
          text: "Starter page",
          active: true,
        },
      ],

      ismobile: false,
      activeNames: [],
      activeapp: [],
      showmodel: "1",
      userinfo: [],
      safeinfo: [],
      loading: true,
      block: false,
      form: {
        name: "",
        tel: "",
        address: "",
        logo: "",
        slogan: "",
      },
      uploaddata: {
        action: "uploadimage",
      },
      defaultLogo: require("@/assets/images/login-logo.webp"),
    };
  },
  mounted() {
    this.title = this.$t("menuitems.setting.commonly");
    this.items = [
      {
        text: this.$t("menuitems.setting.text"),
        href: "/",
      },
      {
        text: this.$t("menuitems.setting.commonly"),
        active: true,
      },
    ];

    this.userinfo = JSON.parse(localStorage.getItem("user"));
    {
      const rid = parseInt(
        this.userinfo.roleid != null
          ? this.userinfo.roleid
          : this.userinfo.roleId,
        10
      );
      if (Number.isFinite(rid) ? rid !== 0 : parseInt(this.userinfo.topuid, 10) >= 1) {
        this.block = true;
      }
    }
    let flag = navigator.userAgent.match(
      /(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag) {
      this.ismobile = true;
    }
    if (!this.block) {
      this.getshopinfo();
    }
  },
  methods: {
    getshopinfo() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "shopinfo",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          if (response.data.data) {
            const data = response.data.data;
            that.form = {
              name: data.name || "",
              tel: data.tel || "",
              address: data.address || "",
              logo: data.logo || "",
              slogan: data.slogan || "",
            };
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    saveshopinfo() {
      var that = this;
      that.loading = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "saveshopinfo",
            name: that.form.name,
            tel: that.form.tel,
            address: that.form.address,
            logo: that.form.logo,
            slogan: that.form.slogan,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          if (response.data.status === 200) {
            refreshMerchantBrand(that.apiuri).then(function () {
              if (typeof that.$meta === "function") {
                const meta = that.$meta();
                if (meta && typeof meta.refresh === "function") {
                  meta.refresh();
                }
              }
            });
            that.$message({
              message: that.$t("global.success"),
              type: "success",
            });
          } else {
            that.$message.error(response.data.msg || that.$t("setting.commonly.logoInvalid"));
          }
        })
        .catch(function () {
          that.loading = false;
        });
    },
    handleLogoSuccess(res) {
      if (res && res.status === 200 && res.imguri) {
        this.form.logo = res.imguri;
      }
    },
    beforeLogoUpload(file) {
      const isImage = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error(this.$t("setting.commonly.logoFormat"));
      }
      if (!isLt2M) {
        this.$message.error(this.$t("global.message.imagesize2m"));
      }
      return isImage && isLt2M;
    },
    clearLogo() {
      this.form.logo = "";
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-loading="loading" v-if="!block">
            <el-form ref="form" :model="form" label-width="100px">
              <el-form-item :label="$t('setting.commonly.logo')">
                <div class="shop-logo-field">
                  <el-upload
                    class="shop-logo-uploader"
                    :action="apiuri"
                    :data="uploaddata"
                    :show-file-list="false"
                    :on-success="handleLogoSuccess"
                    :before-upload="beforeLogoUpload"
                    name="source"
                    accept="image/jpeg,image/png"
                  >
                    <img :src="form.logo || defaultLogo" class="shop-logo-preview" alt="" />
                  </el-upload>
                  <div class="shop-logo-side">
                    <p class="shop-logo-tip">{{ $t("setting.commonly.logoTip") }}</p>
                    <el-button v-if="form.logo" type="text" @click="clearLogo">
                      {{ $t("setting.commonly.clearLogo") }}
                    </el-button>
                  </div>
                </div>
              </el-form-item>
              <el-form-item :label="$t('setting.commonly.shopname')">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item :label="$t('setting.commonly.slogan')">
                <el-input v-model="form.slogan" maxlength="80" show-word-limit></el-input>
              </el-form-item>
              <el-form-item :label="$t('setting.commonly.tel')">
                <el-input v-model="form.tel"></el-input>
              </el-form-item>
              <el-form-item :label="$t('setting.commonly.address')">
                <el-input type="textarea" v-model="form.address"></el-input>
              </el-form-item>
              <el-form-item class="text-right">
                <el-button type="primary" @click="saveshopinfo">
                  {{ $t("etting.commonly.save") }}
                </el-button>
              </el-form-item>
            </el-form>
          </div>
          <div v-else>
            <el-result icon="error" :title="$t('global.error')" :subTitle="$t('global.text.nopermission')">
              <template slot="extra">
                <el-button type="primary" size="medium">返回</el-button>
              </template>
            </el-result>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.shop-logo-field {
  display: flex;
  align-items: center;
  gap: 16px;
}

.shop-logo-uploader {
  line-height: 0;
}

.shop-logo-preview,
.shop-logo-placeholder {
  width: 96px;
  height: 96px;
  border: 1px dashed #d9d9d9;
  border-radius: 8px;
  box-sizing: border-box;
}

.shop-logo-preview {
  object-fit: contain;
  background: #f7f8fa;
}

.shop-logo-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8c939d;
  font-size: 24px;
}

.shop-logo-tip {
  margin: 0 0 4px;
  color: #909399;
  line-height: 1.5;
}
</style>